import { useEffect, useState } from "react";
import { observer } from 'mobx-react';
import { Grid, Box, Typography, Paper, Divider, Button, Stack, FormControlLabel, Switch } from "@mui/material";
import Header from "../shared/header";
import Footer from "../shared/footer";
import styles from './settings.module.scss'
import SettingsUiStore from "./settings-ui-store";
import ChangePasswordModal from "./change-password-modal";
import ChangeEmailModal from "./change-email-modal";

const uiStore = new SettingsUiStore();

const Settings = observer(({ history, context }) => {
    const [showPassword, setShowPassword] = useState(false);
    const [showEmail, setShowEmail] = useState(false);
    const [update, setUpdate] = useState(false);
    const { user } = uiStore;

    useEffect(() => {
        async function fetchData() {
            uiStore.initliazeContext(context);
            uiStore.fetchData();
        }

        fetchData()
    }, [context, update]);


    return (
        <>
            <Header></Header>
            <Grid className='content' container>
                <Box className={styles.wrapper}>
                    <Box sx={{ mt: 2 }}>
                        <Typography variant="h6" color='#242333' fontWeight={700}>Account Settings</Typography>
                    </Box>
                    <Paper variant="round" sx={{ p: 3, mt: 4 }}>
                        <Typography fontWeight={600}>Login</Typography>

                        <Box className={styles.fieldContainer}>
                            <Box>
                                <Typography fontSize='12px'>
                                    Email Address
                                </Typography>
                                <Typography fontSize='14px' fontWeight={600} sx={{ overflow: 'hidden', overflowWrap: 'break-word' }}>
                                    {user?.email}
                                </Typography>
                            </Box>
                            <Button onClick={() => setShowEmail(true)}>
                                Change Email
                            </Button>
                        </Box>
                        <Box className={styles.fieldContainer} sx={{ justifyContent: 'space-between', display: 'flex' }}>
                            <Box>
                                <Typography fontSize='12px'>
                                    Password
                                </Typography>
                                <Typography fontSize='14px' fontWeight={600} sx={{ overflow: 'hidden', overflowWrap: 'break-word' }}>
                                    ****************
                                </Typography>
                            </Box>
                            <Button onClick={() => setShowPassword(true)}>
                                Change Password
                            </Button>
                        </Box>

                        <Divider sx={{ mb: 3 }}></Divider>

                        <Typography sx={{ mb: 2 }} fontWeight={600}>Notification</Typography>

                        <Stack direction='column'>
                            <FormControlLabel sx={{ m: 1 }} componentsProps={{ typography: { fontSize: 14 } }} control={<Switch size="small" checked={user?.emailNotifications} />} label="Email Notification" />
                            <FormControlLabel sx={{ m: 1 }} componentsProps={{ typography: { fontSize: 14 } }} required control={<Switch size="small" />} label="Mobile Notification" />
                        </Stack>

                    </Paper>
                </Box>
            </Grid>
            <Footer></Footer>
            <ChangePasswordModal show={showPassword} setShow={setShowPassword} uiStore={uiStore} />
            <ChangeEmailModal show={showEmail} setShow={setShowEmail} update={() => setUpdate(val => !val)} uiStore={uiStore} />
        </>
    );
});

export default Settings;